<div class="uni-form-field-info" [ngClass]="class">
  <ng-content></ng-content>
</div>
